import FundApplication from './FundApplication';

export default FundApplication;
